import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekday from 'dayjs/plugin/weekday';
import { Dayjs } from 'dayjs';
export { Dayjs };

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(weekday);

export default dayjs;

export const startOfWeek = (value: Dayjs) => dayjs(value).startOf('week');
export const endOfWeek = (value: Dayjs) => dayjs(value).endOf('week');
